/**
 * Exchange Rates API Service
 * Handles fiat currencies and cryptocurrency endpoints
 */

import axiosInstance from '@/lib/axios'
import API_ROUTES from '@/lib/api-routes'
import type {
    FiatCurrenciesResponse,
    CryptocurrenciesResponse,
    UpdateFiatCurrencyRequest,
    UpdateFiatCurrencyResponse,
} from '@/types/exchange-rate'

/**
 * Get all fiat currencies
 * GET /admin/fiat
 */
export const getFiatCurrencies = async () => {
    const response = await axiosInstance.get<FiatCurrenciesResponse>(
        API_ROUTES.EXCHANGE_RATES.FIATS
    )
    return response.data.data
}

/**
 * Get all cryptocurrencies
 * GET /admin/crypto
 */
export const getCryptocurrencies = async () => {
    const response = await axiosInstance.get<CryptocurrenciesResponse>(
        API_ROUTES.CURRENCIES.ALL
    )
    return response.data.data
}

/**
 * Update a fiat currency
 * PATCH /admin/fiat/{fiatId}
 */
export const updateFiatCurrency = async (
    fiatId: string,
    data: UpdateFiatCurrencyRequest
) => {
    const response = await axiosInstance.patch<UpdateFiatCurrencyResponse>(
        API_ROUTES.EXCHANGE_RATES.UPDATE_FIAT(fiatId),
        data
    )
    return response.data.data
}
